import { __awaiter } from 'tslib';
import { Languages, DefaultLanguage } from '@landr/core.models';
import { v4 } from 'uuid';
import '../analytics/AbstractSegmentService.es.js';
import '../analytics/platformName.es.js';
import '../analytics/application.es.js';
import '../analytics/UTMsToCookies.es.js';
import { getXLandrAnalytics } from '../analytics/apiHeaders.es.js';
import '../logs/types/LogLevel.es.js';
import { CommonEventIds } from '../logs/CommonEventIds.es.js';
import '../logs/utils.es.js';
import 'json-stringify-safe';
import '@amplitude/ua-parser-js';
import 'axios';
import { fetchWithRetries } from './fetchWithRetries.es.js';
import { MaxRetryAttempts } from './constants.es.js';
import { extractUserIdFromAuthorizationHeader } from './utils.es.js';

const ApiLanguages = {
    [Languages.English]: 'en-US',
    [Languages.French]: 'fr-FR',
    [Languages.German]: 'de-DE',
    [Languages.Italian]: 'it-IT',
    [Languages.Japanese]: 'ja-JP',
    [Languages.Portuguese]: 'pt-BR',
    [Languages.Spanish]: 'es-ES',
};
const fetchWithCommonHeaders = (input, init, properties) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c;
    const analyticContext = properties.analytics
        ? getXLandrAnalytics(properties.analytics.application, properties.analytics.window, properties.analytics.platformName)
        : undefined;
    const lang = ApiLanguages[(_a = properties.language) !== null && _a !== void 0 ? _a : DefaultLanguage];
    const correlationId = v4();
    const commonHeaders = {
        'X-API-Languages': lang,
        'X-LANDR-ANALYTICS': JSON.stringify(analyticContext),
        'x-landr-featureflags': JSON.stringify((_b = properties.featureFlags) !== null && _b !== void 0 ? _b : {}),
        'X-CorrelationId': correlationId,
    };
    const url = typeof input === 'string' ? input : input.url;
    const retryCount = (_c = properties.retryCount) !== null && _c !== void 0 ? _c : MaxRetryAttempts;
    const headers = init && init.headers
        ? Object.assign(Object.assign({}, init.headers), commonHeaders) : commonHeaders;
    const userId = extractUserIdFromAuthorizationHeader(headers);
    try {
        const response = yield fetchWithRetries(input, Object.assign(Object.assign({}, init), { headers }), retryCount);
        if (!response.ok) {
            properties.log.warn(`Fetch - Response status is not OK: ${response.status}`, CommonEventIds.FetchResponseIsNotOk, undefined, {
                correlationId,
                userId,
                url,
                retryCount,
                status: response.status,
                statusText: response.statusText,
            });
        }
        return response;
    }
    catch (error) {
        properties.log.warn(`Fetch - Failed`, CommonEventIds.FetchFailedError, error, {
            correlationId,
            userId,
            url,
            retryCount,
        });
        throw error;
    }
});

export { fetchWithCommonHeaders };
